import { render, staticRenderFns } from "./MenuComponent.vue?vue&type=template&id=4dff5fb1&"
import script from "./MenuComponent.vue?vue&type=script&lang=ts&"
export * from "./MenuComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports